import React, { Component } from "react";
import { Container } from "@material-ui/core";
import { connect } from "react-redux";
import * as actionsPresentacion from "../../../actions/nuevaPresentacion";
import * as actionsVentanaDialogo from "../../../actions/ventanaDialogo";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router";
import uploadService from "../../../services/upload-files";
import styles from "./styles";

import axios from "../../../http-common";

import Presentacion from "../../Presentacion/Presentacion";
import {
    BotonPrincipal,
    BotonSecundario,
} from "../../common/UI/Personalizaciones/Boton";

class EditarPresentacion extends Component {
    componentDidMount = () => {
        window.scrollTo(0, 0);
        this.props.actualizarAtriutoPresentacion({
            mostrarBackdrop: true,
        });
        this.props.inicializarNuevaPresentacion();

        // this.props.buscarTiposPresentaciones();
        // this.props.buscarTiposPrestaciones();
        // this.props.buscarTiposComprobantes();

        // const idPresentacion = this.props.match.params.idPresentacion;
        // this.props.recuperarPathTemporalParaArchivos(idPresentacion);
        // this.props.buscarDatosPresentacion(idPresentacion, true);

        const requestOne = this.props.buscarTiposPresentaciones();
      //  const requestTwo = this.props.buscarTiposPrestaciones();
       // const requestThree = this.props.buscarTiposComprobantes();

        Promise.all([requestOne/*,requestTwo,requestThree*/]).then(() => {
            const idPresentacion = this.props.match.params.idPresentacion;
            const idTipoPresentacion = this.props.match.params.idTipoPresentacion;
            this.props.buscarTiposPrestaciones(idTipoPresentacion);
            this.props.buscarTiposComprobantes(idTipoPresentacion);
            this.props.recuperarPathTemporalParaArchivos(idPresentacion);
            this.props.buscarDatosPresentacion(idPresentacion, true);
        });

        window.addEventListener("beforeunload", this.mantenerseEnLaPagina);
        window.addEventListener("unload", this.eliminarDatosCargados);
    };

    componentDidUpdate = () => {};

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.mantenerseEnLaPagina);
        window.removeEventListener("unload", this.eliminarDatosCargados);
    }

    mantenerseEnLaPagina(e) {
        var message =
            "Advertecia!\n\nEstá seguro de que desea abandonar la página actual? Perderá todo el contenido cargado hasta el momento.";
        e.returnValue = message;
        return message;
    }

    eliminarDatosCargados = () => {
        if (this.props.pathTemporal !== null) {
            uploadService.cancelarPresentacion(this.props.pathTemporal);
        }
    };

    accionVolver = () => {
        const ventanaConfig = {
            estaVisible: false,
        };
        this.props.actualizarAtriutoVentanaDialogo(ventanaConfig);

        this.eliminarDatosCargados();
        this.props.history.push("/");
    };

    confirmarCancelarPresentacion = () => {
        const ventanaConfig = {
            estaVisible: true,
            titulo: "¿Está seguro que desea salir de la presentación?",
            mensaje: "En caso de salir se perderán los cambios",
            esAlerta: true,
            clickAceptar: this.accionVolver,
            clickCancelar: () =>
                this.props.actualizarAtriutoVentanaDialogo({
                    estaVisible: false,
                }),
        };

        this.props.actualizarAtriutoVentanaDialogo(ventanaConfig);
    };

    render() {
        const { classes, submitValido, estado, mostrarBackdrop } = this.props;

        if (estado.descripcion && estado.descripcion !== "Observado") {
            this.props.history.push(
                "/ver/" + this.props.match.params.idPresentacion + "/" + this.props.idTipoPresentacion
            );
        }

        return (
            <Container disableGutters={true}>
                <Presentacion />
                {!mostrarBackdrop && (
                    <Container
                        disableGutters={true}
                        className={classes.containerBotones}
                    >
                        <BotonSecundario
                            variant="outlined"
                            onClick={this.confirmarCancelarPresentacion}
                            className={classes.btnCancelar}
                        >
                            Cancelar
                        </BotonSecundario>
                        <BotonPrincipal
                            variant="contained"
                            onClick={this.props.enviarPresentacionActualizada}
                            className={classes.btnEnviar}
                            disabled={!submitValido}
                        >
                            Actualizar Presentación
                        </BotonPrincipal>
                    </Container>
                )}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    pathTemporal: state.nuevaPresentacionReducer.pathTemporal,
    emailResponsable: state.nuevaPresentacionReducer.emailResponsable,
    telefonoResponsable: state.nuevaPresentacionReducer.telefonoResponsable,
    submitValido: state.nuevaPresentacionReducer.submitValido,
    estado: state.nuevaPresentacionReducer.estado,
    mostrarBackdrop: state.nuevaPresentacionReducer.mostrarBackdrop,
    idTipoPresentacion: state.nuevaPresentacionReducer.tipoPresentacionSeleccionada,
});

const actionCreators = {
    inicializarNuevaPresentacion:
        actionsPresentacion.inicializarNuevaPresentacion,
    buscarTiposComprobantes: actionsPresentacion.buscarTiposComprobantesPresentacion,
    enviarPresentacionActualizada:
        actionsPresentacion.enviarPresentacionActualizada,
    buscarDatosPresentacion: actionsPresentacion.buscarDatosPresentacion,
    recuperarPathTemporalParaArchivos:
        actionsPresentacion.recuperarPathTemporalParaArchivos,
    buscarTiposPresentaciones: actionsPresentacion.buscarTiposPresentaciones,
    buscarTiposPrestaciones: actionsPresentacion.buscarTiposPrestacionesPresentacion,
    actualizarAtriutoPresentacion:
        actionsPresentacion.actualizarAtriutoPresentacion,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
};

export default connect(
    mapStateToProps,
    actionCreators
)(withStyles(styles)(withRouter(EditarPresentacion)));
